//API Domain Name
import { showConsoleMessage } from "../../util/ConsoleMessage";
import { Language } from "../responsePayload/KnowledgeResponse";

// export const apiDomainName = "api-staging.mjproapps.com/api";
// export const BASE_URI = `https://${apiDomainName}`;

export const apiDomainName = "api.mjproapps.com/api";
export const BASE_URI = `https://${apiDomainName}`;

// export const apiDomainName = "localhost:8000/api";
// export const BASE_URI = `http://${apiDomainName}`;

export const getBaseUri = () => {
  showConsoleMessage("Using Default API URL:", BASE_URI);
  return BASE_URI;
};

export const Endpoint = {
  Knowledge: `${getBaseUri()}/knowledge`,
  KnowledgeId: `${getBaseUri()}/knowledge/{id}`,
  KnowledgeSummary: `${getBaseUri()}/knowledge-summary/`,

  CreateKnowledge: `${getBaseUri()}/knowledge-content/`,
  KnowledgeContent: `${getBaseUri()}/knowledge-content/{id}/`,
  KnowledgeContentBulkUpdateStatus: `${getBaseUri()}/knowledge-content/bulk-update-status/`,
  KnowledgeContentBulkDelete: `${getBaseUri()}/knowledge-content/bulk-delete/`,
  KowledgeContentBulkCreate: `${getBaseUri()}/knowledge-content/bulk-create/`,
  knowledgeContentUpdateReject: `${getBaseUri()}/knowledge-content/update-to-reject/`,
  KnowledgeContentCheckSimilarKnowledge: `${getBaseUri()}/knowledge-content/check-similar-knowledge/`,

  Brain: `${getBaseUri()}/brain/{id}`,
  BrainSearch: `${getBaseUri()}/brain/search/`,
  BrainKnowledgeBulkUpdate: `${getBaseUri()}/brain/bulk-add-to-brain/`,
  BrainBulkRemove: `${getBaseUri()}/brain/bulk-remove-from-brain/`,

  Context: `${getBaseUri()}/context/`,
  ContextDelete: `${getBaseUri()}/context/{id}/`,
  ContextAI: `${getBaseUri()}/context-ai/{id}/`,

  Category: `${getBaseUri()}/categories/`,
  SubCategory: `${getBaseUri()}/subcategories/`,

  Login: `${getBaseUri()}/login/`,
  Refresh: `${getBaseUri()}/refresh/`,
  User: `${getBaseUri()}/user/`,
  Logout: `${getBaseUri()}/logout/`,

  Prompt: `${getBaseUri()}/prompt/`,
  PromptPatch: `${getBaseUri()}/prompt/{id}`,
  PromptBathDefaultUpdate: `${getBaseUri()}/prompt/bulk-reset-defaults/`,

  Node: `${getBaseUri()}/node/`,
  NodePatch: `${getBaseUri()}/node/{id}`,

  Image: `${getBaseUri()}/image/{id}`,
  ImagePost: `${getBaseUri()}/image/`,

  Intent: `${getBaseUri()}/intent/{id}`,
  IntentPost: `${getBaseUri()}/intent/`,

  Ragchat: `${getBaseUri()}/chatbot/rag-chat/`,
  chatbotUserMessage: `${getBaseUri()}/chatbot/user-message/`,
  chatbotHitlMessage: `${getBaseUri()}/chatbot/hitl-message/`,
  chatbotEndConservation: `${getBaseUri()}/chatbot/end-conversation/`,
  chatRoomStatus: `${getBaseUri()}/chatbot/chat-room-status/{id}`,

  chatHistory: `${getBaseUri()}/chat-history/`,

  sop: `${getBaseUri()}/sop/{id}`,
  sopPost: `${getBaseUri()}/sop/`,

  Export: `${getBaseUri()}/export-fixture/sap/{id}/`,
};

//API Constants
export const notificationToken = String(
  process.env.REACT_APP_NOTIFICATION_TOKEN
);
export const sha256Salt = String(process.env.REACT_APP_SHA256SALT);
export const secretKey = String(process.env.REACT_APP_SECRET_KEY);
export const apiKey = String(process.env.REACT_APP_API_KEY || "");

export const ragKey = String(process.env.REACT_APP_RAG_API_KEY);
export const ragMemberSecretKey = String(
  process.env.REACT_APP_RAG_MEMBER_SECRET_KEY
);
export const defaultLanguage = Language.ENGLISH;
